<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script setup>
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
</script>
<style lang="scss">
@import "@/assets/commonCv.css";
@import "@/assets/common.css";

/* 特别针对 IE 的解决方案 */
@supports (-ms-ime-align: auto) {
  * {
    border: 0;
    padding: 0;
    margin: 0;
  }
}

.titles {
  height: 60px;
  border-bottom: 1px dotted #ccc;
  color: #1f5781;
  font-size: 16px;
  font-weight: bolder;
  text-align: center;
  padding-top: 10px;
  padding-right: 15px;
  margin-bottom: 10px;
  padding-left: 15px;
}

#app {
  height: 100vh;
}
html,
body {
  margin: 0;
  padding: 0;
}

/* 定义滚动条的宽度和背景颜色 */
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: #f5f5f5;
}

/* 定义滚动条轨道的样式，包括内阴影和圆角 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/* 定义滑块的样式，包括圆角和内阴影 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d3d3d3;
}

/* 定义滑块在鼠标悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #40a0ff;
}
</style>
